import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(default)/image-to-prompt/page.tsx");
